import { createIcon } from '@chakra-ui/react';

export const ChevronUpIcon = createIcon({
  displayName: 'ChevronUpIcon',
  path: (
    <>
      <svg viewBox="0 0 36 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M33.84 18.1002C33.46 18.1002 33.08 17.9602 32.78 17.6602L19.74 4.62016C18.78 3.66016 17.22 3.66016 16.26 4.62016L3.22004 17.6602C2.64004 18.2402 1.68004 18.2402 1.10004 17.6602C0.520039 17.0802 0.520039 16.1202 1.10004 15.5402L14.14 2.50016C16.26 0.380156 19.72 0.380156 21.86 2.50016L34.9 15.5402C35.48 16.1202 35.48 17.0802 34.9 17.6602C34.6 17.9402 34.22 18.1002 33.84 18.1002Z"
          fill="currentColor"
        />
      </svg>
    </>
  ),
});
